import PropTypes from 'prop-types';
import { Svg } from '../common/Svg.js';
/* global isTeacher */ // defined as a page param

function SelfStarter({ hasCreatedFirstProject }) {
    const descriptionText = isTeacher ? 'Post your first project' : 'Posted their first project';
    function awardClasses() {
        return hasCreatedFirstProject ? 'earned' : 'not-yet';
    }

    return (
        <section className="achievement">
            <div aria-label='Badge for starting a first project' className={'badge self-starter ' + awardClasses()}></div>
            <h5>Self Starter</h5>
            {descriptionText}
        </section>);
}

SelfStarter.propTypes = { hasCreatedFirstProject: PropTypes.bool.isRequired };

function GotMail({ hasUsedSendFriend }) {
    const descriptionText = isTeacher ? 'Share a project to someone you know via email' : 'Shared a project to someone you know via email';

    function awardClasses() {
        return hasUsedSendFriend ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for sending a project via email' className={'badge got-mail ' + awardClasses()}></div>
            <h5>They&apos;ve Got Mail!</h5>
            {descriptionText}
        </section>);
}

GotMail.propTypes = { hasUsedSendFriend: PropTypes.bool.isRequired };

function BigThanker({ numSentProjectMessage }) {
    const descriptionText = isTeacher ? 'Thank a donor' : 'Thanked a donor';

    function awardClasses() {
        return numSentProjectMessage ? 'earned' : 'not-yet';
    }

    function toolTipClass() {
        return isTeacher ? '' : 'donor';
    }

    return (
        <section className='achievement'>
            <div aria-label='Badge for thanking a donor' className={'badge thanker ' + awardClasses()}></div>
            <h5>Big Thanker!
                <span className={'tooltip-wrapper ' + toolTipClass()}>
                    <Svg icon='help' />
                    <span className="hover-tooltip">Thanking a donor on your dashboard or project page activates this badge. </span>
                </span>

            </h5>
            {descriptionText}
            <div className='counter'>
                {numSentProjectMessage}
            </div>
        </section>);
}

BigThanker.propTypes = { numSentProjectMessage: PropTypes.number.isRequired };

function FirstProject({ lifetimeFullyFundedProjects }) {
    const descriptionText = isTeacher ? 'Get your first project funded' : 'Got their first project funded';

    function awardClasses() {
        return lifetimeFullyFundedProjects ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for getting first project funded' className={'badge first-project ' + awardClasses()}></div>
            <h5>First Project Funded</h5>
            {descriptionText}
        </section>);
}

FirstProject.propTypes = { lifetimeFullyFundedProjects: PropTypes.number.isRequired };

function FifthProject({ lifetimeFullyFundedProjects }) {
    const descriptionText = isTeacher ? 'Get your fifth project funded' : 'Got their fifth project funded';

    function awardClasses() {
        return lifetimeFullyFundedProjects > 4 ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for getting fifth project funded' className={'badge fifth-project ' + awardClasses()}></div>
            <h5>High Five!</h5>

            {descriptionText}

        </section>);
}

FifthProject.propTypes = { lifetimeFullyFundedProjects: PropTypes.number.isRequired };

function TenthProject({ lifetimeFullyFundedProjects }) {
    const descriptionText = isTeacher ? 'Get your tenth project funded' : 'Got their tenth project funded';

    function awardClasses() {
        return lifetimeFullyFundedProjects > 9 ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for getting tenth project funded' className={'badge tenth-project ' + awardClasses()}></div>
            <h5>The Big Ten</h5>

            {descriptionText}

        </section>);
}

TenthProject.propTypes = { lifetimeFullyFundedProjects: PropTypes.number.isRequired };

function TYP({ numStudentTYPCompleted }) {
    const descriptionText = isTeacher ? 'Complete a Thank-you package' : 'Completed a Thank-you package';

    function awardClasses() {
        return numStudentTYPCompleted ? 'earned' : 'not-yet';
    }

    function toolTipClass() {
        return isTeacher ? '' : 'donor';
    }

    return (
        <section className='achievement'>
            <div aria-label='Badge for completing thank you packages' className={'badge typ ' + awardClasses()}></div>
            <h5>Signed, Sealed, Delivered!
                <span className={'tooltip-wrapper ' + toolTipClass()}>
                    <Svg icon='help' />
                    <span className="hover-tooltip">Completing a thank-you package will activate this badge.
                        <a href='https://help.donorschoose.org/hc/en-us/articles/202137803-What-is-a-thank-you-package-' target='_blank' rel="noreferrer noopener"> Learn more</a>
                    </span>
                </span>
            </h5>
            {descriptionText}
            <div className='counter'>
                {numStudentTYPCompleted}
            </div>
        </section>);
}

TYP.propTypes = { numStudentTYPCompleted: PropTypes.number.isRequired };

function Referred({ numTeachersReferred }) {
    const descriptionText = isTeacher ? 'Refer a teacher' : 'Referred a teacher';

    function awardClasses() {
        return numTeachersReferred ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for referrals' className={'badge referred ' + awardClasses()}></div>
            <h5>Word of Mouth</h5>
            {descriptionText}
            <div className='counter'>
                {numTeachersReferred}
            </div>

        </section>);
}

Referred.propTypes = { numTeachersReferred: PropTypes.number.isRequired };

function BTS({ postedDuringFY23BackToSchool }) {
    const descriptionText = isTeacher ? 'Post a project during back to school season' : 'Posted a project during back to school season';

    function awardClasses() {
        return postedDuringFY23BackToSchool ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for posting a project during back to school' className={'badge bts ' + awardClasses()}></div>
            <h5>Stock Up!</h5>
            {descriptionText}
        </section>);
}

BTS.propTypes = { postedDuringFY23BackToSchool: PropTypes.bool.isRequired };

function Restock({ postedDuringFY23NewYear }) {
    const descriptionText = isTeacher ? 'Post a project for the new year' : 'Posted a project for the new year';

    function awardClasses() {
        return postedDuringFY23NewYear ? 'earned' : 'not-yet';
    }
    return (
        <section className='achievement'>
            <div aria-label='Badge for posting a project during the new year' className={'badge restock ' + awardClasses()}></div>
            <h5>Restock</h5>
            {descriptionText}
        </section>);
}

Restock.propTypes = { postedDuringFY23NewYear: PropTypes.bool.isRequired };

export { SelfStarter, GotMail, BigThanker, FirstProject, FifthProject, TenthProject, TYP, Referred, BTS, Restock };
